import { createSelector } from '@ngrx/store';

import { type NavMenu } from '@blaze-shared/elements-domain';

import { getEngineState } from '../engine/engine-adapters';

export const getNavMenuState = createSelector(getEngineState, (state) => state.navMenu);

export const selectEntities = createSelector(getNavMenuState, (state) => state.entities);

export const selectItems = createSelector(getNavMenuState, (state) =>
  state.ids.map((id) => state.entities[id]).filter((item): item is NavMenu.SharedItem => !!item),
);

export const selectLastAdded = createSelector(getNavMenuState, (state) => state.lastAdded);
